<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre14" id="pgepubid00000">The Serpent's Tooth</h1>
<h2 class="sigil_not_in_toc">B. M. Croker</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?a04885a8